export const editorHeaderTheme = {
  boxShadow: 'palette.black:0.06',
  breadCrumb: {
    item: 'palette.neutral.80',
  },
  container: 'palette.surface.2',
  nameEditor: {
    cancelButton: 'palette.error.70',
    saveButton: 'palette.success.70',
  },
};
